import { jsx as D, jsxs as xe, Fragment as ct } from "react/jsx-runtime";
import * as s from "react";
import f, { useMemo as En, useLayoutEffect as bn, useEffect as Dn } from "react";
import { c as fe } from "../clsx-OuTLNxxd.js";
import * as Rn from "react-dom";
import Sn from "react-dom";
import { h as Tn, R as Cn } from "../index-B4nkmsKV.js";
import '../Drawer.css';function oe(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function dt(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Rt(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const a = dt(o, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const a = r[o];
          typeof a == "function" ? a() : dt(e[o], null);
        }
      };
  };
}
function ue(...e) {
  return s.useCallback(Rt(...e), e);
}
function On(e, t) {
  const n = s.createContext(t), r = (a) => {
    const { children: u, ...i } = a, d = s.useMemo(() => i, Object.values(i));
    return /* @__PURE__ */ D(n.Provider, { value: d, children: u });
  };
  r.displayName = e + "Provider";
  function o(a) {
    const u = s.useContext(n);
    if (u) return u;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function Nn(e, t = []) {
  let n = [];
  function r(a, u) {
    const i = s.createContext(u), d = n.length;
    n = [...n, u];
    const l = (m) => {
      var g;
      const { scope: p, children: R, ...P } = m, w = ((g = p == null ? void 0 : p[e]) == null ? void 0 : g[d]) || i, A = s.useMemo(() => P, Object.values(P));
      return /* @__PURE__ */ D(w.Provider, { value: A, children: R });
    };
    l.displayName = a + "Provider";
    function c(m, p) {
      var w;
      const R = ((w = p == null ? void 0 : p[e]) == null ? void 0 : w[d]) || i, P = s.useContext(R);
      if (P) return P;
      if (u !== void 0) return u;
      throw new Error(`\`${m}\` must be used within \`${a}\``);
    }
    return [l, c];
  }
  const o = () => {
    const a = n.map((u) => s.createContext(u));
    return function(i) {
      const d = (i == null ? void 0 : i[e]) || a;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: d } }),
        [i, d]
      );
    };
  };
  return o.scopeName = e, [r, Pn(o, ...t)];
}
function Pn(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const u = r.reduce((i, { useScope: d, scopeName: l }) => {
        const m = d(a)[`__scope${l}`];
        return { ...i, ...m };
      }, {});
      return s.useMemo(() => ({ [`__scope${t.scopeName}`]: u }), [u]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var be = globalThis != null && globalThis.document ? s.useLayoutEffect : () => {
}, xn = s[" useId ".trim().toString()] || (() => {
}), An = 0;
function Ue(e) {
  const [t, n] = s.useState(xn());
  return be(() => {
    n((r) => r ?? String(An++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var _n = s[" useInsertionEffect ".trim().toString()] || be;
function In({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, a, u] = Mn({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, d = i ? e : o;
  {
    const c = s.useRef(e !== void 0);
    s.useEffect(() => {
      const m = c.current;
      m !== i && console.warn(
        `${r} is changing from ${m ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), c.current = i;
    }, [i, r]);
  }
  const l = s.useCallback(
    (c) => {
      var m;
      if (i) {
        const p = $n(c) ? c(e) : c;
        p !== e && ((m = u.current) == null || m.call(u, p));
      } else
        a(c);
    },
    [i, e, a, u]
  );
  return [d, l];
}
function Mn({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = s.useState(e), o = s.useRef(n), a = s.useRef(t);
  return _n(() => {
    a.current = t;
  }, [t]), s.useEffect(() => {
    var u;
    o.current !== n && ((u = a.current) == null || u.call(a, n), o.current = n);
  }, [n, o]), [n, r, a];
}
function $n(e) {
  return typeof e == "function";
}
// @__NO_SIDE_EFFECTS__
function St(e) {
  const t = /* @__PURE__ */ Ln(e), n = s.forwardRef((r, o) => {
    const { children: a, ...u } = r, i = s.Children.toArray(a), d = i.find(kn);
    if (d) {
      const l = d.props.children, c = i.map((m) => m === d ? s.Children.count(l) > 1 ? s.Children.only(null) : s.isValidElement(l) ? l.props.children : null : m);
      return /* @__PURE__ */ D(t, { ...u, ref: o, children: s.isValidElement(l) ? s.cloneElement(l, void 0, c) : null });
    }
    return /* @__PURE__ */ D(t, { ...u, ref: o, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function Ln(e) {
  const t = s.forwardRef((n, r) => {
    const { children: o, ...a } = n;
    if (s.isValidElement(o)) {
      const u = Wn(o), i = Un(a, o.props);
      return o.type !== s.Fragment && (i.ref = r ? Rt(r, u) : u), s.cloneElement(o, i);
    }
    return s.Children.count(o) > 1 ? s.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Fn = Symbol("radix.slottable");
function kn(e) {
  return s.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Fn;
}
function Un(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...i) => {
      const d = a(...i);
      return o(...i), d;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Wn(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Bn = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Q = Bn.reduce((e, t) => {
  const n = /* @__PURE__ */ St(`Primitive.${t}`), r = s.forwardRef((o, a) => {
    const { asChild: u, ...i } = o, d = u ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ D(d, { ...i, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Hn(e, t) {
  e && Rn.flushSync(() => e.dispatchEvent(t));
}
function De(e) {
  const t = s.useRef(e);
  return s.useEffect(() => {
    t.current = e;
  }), s.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Vn(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = De(e);
  s.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var zn = "DismissableLayer", Ye = "dismissableLayer.update", jn = "dismissableLayer.pointerDownOutside", qn = "dismissableLayer.focusOutside", ft, Tt = s.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Ct = s.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: u,
      onDismiss: i,
      ...d
    } = e, l = s.useContext(Tt), [c, m] = s.useState(null), p = (c == null ? void 0 : c.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, R] = s.useState({}), P = ue(t, (v) => m(v)), w = Array.from(l.layers), [A] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), g = w.indexOf(A), _ = c ? w.indexOf(c) : -1, O = l.layersWithOutsidePointerEventsDisabled.size > 0, h = _ >= g, W = Gn((v) => {
      const S = v.target, T = [...l.branches].some((L) => L.contains(S));
      !h || T || (o == null || o(v), u == null || u(v), v.defaultPrevented || i == null || i());
    }, p), X = Xn((v) => {
      const S = v.target;
      [...l.branches].some((L) => L.contains(S)) || (a == null || a(v), u == null || u(v), v.defaultPrevented || i == null || i());
    }, p);
    return Vn((v) => {
      _ === l.layers.size - 1 && (r == null || r(v), !v.defaultPrevented && i && (v.preventDefault(), i()));
    }, p), s.useEffect(() => {
      if (c)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (ft = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(c)), l.layers.add(c), mt(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = ft);
        };
    }, [c, p, n, l]), s.useEffect(() => () => {
      c && (l.layers.delete(c), l.layersWithOutsidePointerEventsDisabled.delete(c), mt());
    }, [c, l]), s.useEffect(() => {
      const v = () => R({});
      return document.addEventListener(Ye, v), () => document.removeEventListener(Ye, v);
    }, []), /* @__PURE__ */ D(
      Q.div,
      {
        ...d,
        ref: P,
        style: {
          pointerEvents: O ? h ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: oe(e.onFocusCapture, X.onFocusCapture),
        onBlurCapture: oe(e.onBlurCapture, X.onBlurCapture),
        onPointerDownCapture: oe(
          e.onPointerDownCapture,
          W.onPointerDownCapture
        )
      }
    );
  }
);
Ct.displayName = zn;
var Yn = "DismissableLayerBranch", Kn = s.forwardRef((e, t) => {
  const n = s.useContext(Tt), r = s.useRef(null), o = ue(t, r);
  return s.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ D(Q.div, { ...e, ref: o });
});
Kn.displayName = Yn;
function Gn(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = De(e), r = s.useRef(!1), o = s.useRef(() => {
  });
  return s.useEffect(() => {
    const a = (i) => {
      if (i.target && !r.current) {
        let d = function() {
          Ot(
            jn,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = d, t.addEventListener("click", o.current, { once: !0 })) : d();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, u = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(u), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Xn(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = De(e), r = s.useRef(!1);
  return s.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && Ot(qn, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function mt() {
  const e = new CustomEvent(Ye);
  document.dispatchEvent(e);
}
function Ot(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Hn(o, a) : o.dispatchEvent(a);
}
var We = "focusScope.autoFocusOnMount", Be = "focusScope.autoFocusOnUnmount", pt = { bubbles: !1, cancelable: !0 }, Zn = "FocusScope", Nt = s.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...u
  } = e, [i, d] = s.useState(null), l = De(o), c = De(a), m = s.useRef(null), p = ue(t, (w) => d(w)), R = s.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  s.useEffect(() => {
    if (r) {
      let w = function(O) {
        if (R.paused || !i) return;
        const h = O.target;
        i.contains(h) ? m.current = h : re(m.current, { select: !0 });
      }, A = function(O) {
        if (R.paused || !i) return;
        const h = O.relatedTarget;
        h !== null && (i.contains(h) || re(m.current, { select: !0 }));
      }, g = function(O) {
        if (document.activeElement === document.body)
          for (const W of O)
            W.removedNodes.length > 0 && re(i);
      };
      document.addEventListener("focusin", w), document.addEventListener("focusout", A);
      const _ = new MutationObserver(g);
      return i && _.observe(i, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", w), document.removeEventListener("focusout", A), _.disconnect();
      };
    }
  }, [r, i, R.paused]), s.useEffect(() => {
    if (i) {
      gt.add(R);
      const w = document.activeElement;
      if (!i.contains(w)) {
        const g = new CustomEvent(We, pt);
        i.addEventListener(We, l), i.dispatchEvent(g), g.defaultPrevented || (Jn(rr(Pt(i)), { select: !0 }), document.activeElement === w && re(i));
      }
      return () => {
        i.removeEventListener(We, l), setTimeout(() => {
          const g = new CustomEvent(Be, pt);
          i.addEventListener(Be, c), i.dispatchEvent(g), g.defaultPrevented || re(w ?? document.body, { select: !0 }), i.removeEventListener(Be, c), gt.remove(R);
        }, 0);
      };
    }
  }, [i, l, c, R]);
  const P = s.useCallback(
    (w) => {
      if (!n && !r || R.paused) return;
      const A = w.key === "Tab" && !w.altKey && !w.ctrlKey && !w.metaKey, g = document.activeElement;
      if (A && g) {
        const _ = w.currentTarget, [O, h] = Qn(_);
        O && h ? !w.shiftKey && g === h ? (w.preventDefault(), n && re(O, { select: !0 })) : w.shiftKey && g === O && (w.preventDefault(), n && re(h, { select: !0 })) : g === _ && w.preventDefault();
      }
    },
    [n, r, R.paused]
  );
  return /* @__PURE__ */ D(Q.div, { tabIndex: -1, ...u, ref: p, onKeyDown: P });
});
Nt.displayName = Zn;
function Jn(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (re(r, { select: t }), document.activeElement !== n) return;
}
function Qn(e) {
  const t = Pt(e), n = vt(t, e), r = vt(t.reverse(), e);
  return [n, r];
}
function Pt(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function vt(e, t) {
  for (const n of e)
    if (!er(n, { upTo: t })) return n;
}
function er(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function tr(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function re(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && tr(e) && t && e.select();
  }
}
var gt = nr();
function nr() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = ht(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = ht(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function ht(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function rr(e) {
  return e.filter((t) => t.tagName !== "A");
}
var or = "Portal", xt = s.forwardRef((e, t) => {
  var i;
  const { container: n, ...r } = e, [o, a] = s.useState(!1);
  be(() => a(!0), []);
  const u = n || o && ((i = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : i.body);
  return u ? Sn.createPortal(/* @__PURE__ */ D(Q.div, { ...r, ref: t }), u) : null;
});
xt.displayName = or;
function ar(e, t) {
  return s.useReducer((n, r) => t[n][r] ?? n, e);
}
var _e = (e) => {
  const { present: t, children: n } = e, r = ir(t), o = typeof n == "function" ? n({ present: r.isPresent }) : s.Children.only(n), a = ue(r.ref, sr(o));
  return typeof n == "function" || r.isPresent ? s.cloneElement(o, { ref: a }) : null;
};
_e.displayName = "Presence";
function ir(e) {
  const [t, n] = s.useState(), r = s.useRef(null), o = s.useRef(e), a = s.useRef("none"), u = e ? "mounted" : "unmounted", [i, d] = ar(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const l = Oe(r.current);
    a.current = i === "mounted" ? l : "none";
  }, [i]), be(() => {
    const l = r.current, c = o.current;
    if (c !== e) {
      const p = a.current, R = Oe(l);
      e ? d("MOUNT") : R === "none" || (l == null ? void 0 : l.display) === "none" ? d("UNMOUNT") : d(c && p !== R ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, d]), be(() => {
    if (t) {
      let l;
      const c = t.ownerDocument.defaultView ?? window, m = (R) => {
        const w = Oe(r.current).includes(CSS.escape(R.animationName));
        if (R.target === t && w && (d("ANIMATION_END"), !o.current)) {
          const A = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = c.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = A);
          });
        }
      }, p = (R) => {
        R.target === t && (a.current = Oe(r.current));
      };
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", m), t.addEventListener("animationend", m), () => {
        c.clearTimeout(l), t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", m), t.removeEventListener("animationend", m);
      };
    } else
      d("ANIMATION_END");
  }, [t, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: s.useCallback((l) => {
      r.current = l ? getComputedStyle(l) : null, n(l);
    }, [])
  };
}
function Oe(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function sr(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var He = 0;
function ur() {
  s.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? wt()), document.body.insertAdjacentElement("beforeend", e[1] ?? wt()), He++, () => {
      He === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), He--;
    };
  }, []);
}
function wt() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Ie = "Dialog", [At] = Nn(Ie), [lr, K] = At(Ie), _t = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    modal: u = !0
  } = e, i = s.useRef(null), d = s.useRef(null), [l, c] = In({
    prop: r,
    defaultProp: o ?? !1,
    onChange: a,
    caller: Ie
  });
  return /* @__PURE__ */ D(
    lr,
    {
      scope: t,
      triggerRef: i,
      contentRef: d,
      contentId: Ue(),
      titleId: Ue(),
      descriptionId: Ue(),
      open: l,
      onOpenChange: c,
      onOpenToggle: s.useCallback(() => c((m) => !m), [c]),
      modal: u,
      children: n
    }
  );
};
_t.displayName = Ie;
var It = "DialogTrigger", Mt = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = K(It, n), a = ue(t, o.triggerRef);
    return /* @__PURE__ */ D(
      Q.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": Je(o.open),
        ...r,
        ref: a,
        onClick: oe(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Mt.displayName = It;
var Xe = "DialogPortal", [cr, $t] = At(Xe, {
  forceMount: void 0
}), Lt = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, a = K(Xe, t);
  return /* @__PURE__ */ D(cr, { scope: t, forceMount: n, children: s.Children.map(r, (u) => /* @__PURE__ */ D(_e, { present: n || a.open, children: /* @__PURE__ */ D(xt, { asChild: !0, container: o, children: u }) })) });
};
Lt.displayName = Xe;
var Ae = "DialogOverlay", Ft = s.forwardRef(
  (e, t) => {
    const n = $t(Ae, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = K(Ae, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ D(_e, { present: r || a.open, children: /* @__PURE__ */ D(fr, { ...o, ref: t }) }) : null;
  }
);
Ft.displayName = Ae;
var dr = /* @__PURE__ */ St("DialogOverlay.RemoveScroll"), fr = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = K(Ae, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ D(Cn, { as: dr, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ D(
        Q.div,
        {
          "data-state": Je(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), se = "DialogContent", kt = s.forwardRef(
  (e, t) => {
    const n = $t(se, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = K(se, e.__scopeDialog);
    return /* @__PURE__ */ D(_e, { present: r || a.open, children: a.modal ? /* @__PURE__ */ D(mr, { ...o, ref: t }) : /* @__PURE__ */ D(pr, { ...o, ref: t }) });
  }
);
kt.displayName = se;
var mr = s.forwardRef(
  (e, t) => {
    const n = K(se, e.__scopeDialog), r = s.useRef(null), o = ue(t, n.contentRef, r);
    return s.useEffect(() => {
      const a = r.current;
      if (a) return Tn(a);
    }, []), /* @__PURE__ */ D(
      Ut,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: oe(e.onCloseAutoFocus, (a) => {
          var u;
          a.preventDefault(), (u = n.triggerRef.current) == null || u.focus();
        }),
        onPointerDownOutside: oe(e.onPointerDownOutside, (a) => {
          const u = a.detail.originalEvent, i = u.button === 0 && u.ctrlKey === !0;
          (u.button === 2 || i) && a.preventDefault();
        }),
        onFocusOutside: oe(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), pr = s.forwardRef(
  (e, t) => {
    const n = K(se, e.__scopeDialog), r = s.useRef(!1), o = s.useRef(!1);
    return /* @__PURE__ */ D(
      Ut,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var u, i;
          (u = e.onCloseAutoFocus) == null || u.call(e, a), a.defaultPrevented || (r.current || (i = n.triggerRef.current) == null || i.focus(), a.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var d, l;
          (d = e.onInteractOutside) == null || d.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const u = a.target;
          ((l = n.triggerRef.current) == null ? void 0 : l.contains(u)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), Ut = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: a, ...u } = e, i = K(se, n), d = s.useRef(null), l = ue(t, d);
    return ur(), /* @__PURE__ */ xe(ct, { children: [
      /* @__PURE__ */ D(
        Nt,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ D(
            Ct,
            {
              role: "dialog",
              id: i.contentId,
              "aria-describedby": i.descriptionId,
              "aria-labelledby": i.titleId,
              "data-state": Je(i.open),
              ...u,
              ref: l,
              onDismiss: () => i.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ xe(ct, { children: [
        /* @__PURE__ */ D(vr, { titleId: i.titleId }),
        /* @__PURE__ */ D(hr, { contentRef: d, descriptionId: i.descriptionId })
      ] })
    ] });
  }
), Ze = "DialogTitle", Wt = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = K(Ze, n);
    return /* @__PURE__ */ D(Q.h2, { id: o.titleId, ...r, ref: t });
  }
);
Wt.displayName = Ze;
var Bt = "DialogDescription", Ht = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = K(Bt, n);
    return /* @__PURE__ */ D(Q.p, { id: o.descriptionId, ...r, ref: t });
  }
);
Ht.displayName = Bt;
var Vt = "DialogClose", zt = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = K(Vt, n);
    return /* @__PURE__ */ D(
      Q.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: oe(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
zt.displayName = Vt;
function Je(e) {
  return e ? "open" : "closed";
}
var jt = "DialogTitleWarning", [yo, qt] = On(jt, {
  contentName: se,
  titleName: Ze,
  docsSlug: "dialog"
}), vr = ({ titleId: e }) => {
  const t = qt(jt), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return s.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, gr = "DialogDescriptionWarning", hr = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${qt(gr).contentName}}.`;
  return s.useEffect(() => {
    var a;
    const o = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, wr = _t, yr = Mt, Er = Lt, br = Ft, Dr = kt, Rr = Wt, Sr = Ht, Tr = zt;
function Cr(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const Yt = f.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), Re = () => {
  const e = f.useContext(Yt);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
Cr(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function Or() {
  const e = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(e) && /Mobile/.test(e) || // Android Firefox
  /FxiOS/.test(e));
}
function Nr() {
  return Qe(/^Mac/);
}
function Pr() {
  return Qe(/^iPhone/);
}
function yt() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function xr() {
  return Qe(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Nr() && navigator.maxTouchPoints > 1;
}
function Kt() {
  return Pr() || xr();
}
function Qe(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const Ar = 24, _r = typeof window < "u" ? bn : Dn;
function Et(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
const Ve = typeof document < "u" && window.visualViewport;
function bt(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function Gt(e) {
  for (bt(e) && (e = e.parentElement); e && !bt(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const Ir = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let Ne = 0, ze;
function Mr(e = {}) {
  let { isDisabled: t } = e;
  _r(() => {
    if (!t)
      return Ne++, Ne === 1 && Kt() && (ze = $r()), () => {
        Ne--, Ne === 0 && (ze == null || ze());
      };
  }, [
    t
  ]);
}
function $r() {
  let e, t = 0, n = (m) => {
    e = Gt(m.target), !(e === document.documentElement && e === document.body) && (t = m.changedTouches[0].pageY);
  }, r = (m) => {
    if (!e || e === document.documentElement || e === document.body) {
      m.preventDefault();
      return;
    }
    let p = m.changedTouches[0].pageY, R = e.scrollTop, P = e.scrollHeight - e.clientHeight;
    P !== 0 && ((R <= 0 && p > t || R >= P && p < t) && m.preventDefault(), t = p);
  }, o = (m) => {
    let p = m.target;
    Ke(p) && p !== document.activeElement && (m.preventDefault(), p.style.transform = "translateY(-2000px)", p.focus(), requestAnimationFrame(() => {
      p.style.transform = "";
    }));
  }, a = (m) => {
    let p = m.target;
    Ke(p) && (p.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      p.style.transform = "", Ve && (Ve.height < window.innerHeight ? requestAnimationFrame(() => {
        Dt(p);
      }) : Ve.addEventListener("resize", () => Dt(p), {
        once: !0
      }));
    }));
  }, u = () => {
    window.scrollTo(0, 0);
  }, i = window.pageXOffset, d = window.pageYOffset, l = Et(Lr(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let c = Et(ye(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), ye(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), ye(document, "touchend", o, {
    passive: !1,
    capture: !0
  }), ye(document, "focus", a, !0), ye(window, "scroll", u));
  return () => {
    l(), c(), window.scrollTo(i, d);
  };
}
function Lr(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function ye(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function Dt(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let n = Gt(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      let r = n.getBoundingClientRect().top, o = e.getBoundingClientRect().top, a = e.getBoundingClientRect().bottom;
      const u = n.getBoundingClientRect().bottom + Ar;
      a > u && (n.scrollTop += o - r);
    }
    e = n.parentElement;
  }
}
function Ke(e) {
  return e instanceof HTMLInputElement && !Ir.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function Fr(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function kr(...e) {
  return (t) => e.forEach((n) => Fr(n, t));
}
function Xt(...e) {
  return s.useCallback(kr(...e), e);
}
const Zt = /* @__PURE__ */ new WeakMap();
function F(e, t, n = !1) {
  if (!e || !(e instanceof HTMLElement)) return;
  let r = {};
  Object.entries(t).forEach(([o, a]) => {
    if (o.startsWith("--")) {
      e.style.setProperty(o, a);
      return;
    }
    r[o] = e.style[o], e.style[o] = a;
  }), !n && Zt.set(e, r);
}
function Ur(e, t) {
  if (!e || !(e instanceof HTMLElement)) return;
  let n = Zt.get(e);
  n && (e.style[t] = n[t]);
}
const $ = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function Pe(e, t) {
  if (!e)
    return null;
  const n = window.getComputedStyle(e), r = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let o = r.match(/^matrix3d\((.+)\)$/);
  return o ? parseFloat(o[1].split(", ")[$(t) ? 13 : 12]) : (o = r.match(/^matrix\((.+)\)$/), o ? parseFloat(o[1].split(", ")[$(t) ? 5 : 4]) : null);
}
function Wr(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function je(e, t) {
  if (!e) return () => {
  };
  const n = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = n;
  };
}
function Br(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
const I = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, Jt = 0.4, Hr = 0.25, Vr = 100, Qt = 8, ie = 16, Ge = 26, qe = "vaul-dragging";
function en(e) {
  const t = f.useRef(e);
  return f.useEffect(() => {
    t.current = e;
  }), f.useMemo(() => (...n) => t.current == null ? void 0 : t.current.call(t, ...n), []);
}
function zr({ defaultProp: e, onChange: t }) {
  const n = f.useState(e), [r] = n, o = f.useRef(r), a = en(t);
  return f.useEffect(() => {
    o.current !== r && (a(r), o.current = r);
  }, [
    r,
    o,
    a
  ]), n;
}
function tn({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = zr({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, u = a ? e : r, i = en(n), d = f.useCallback((l) => {
    if (a) {
      const m = typeof l == "function" ? l(e) : l;
      m !== e && i(m);
    } else
      o(l);
  }, [
    a,
    e,
    o,
    i
  ]);
  return [
    u,
    d
  ];
}
function jr({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: n, drawerRef: r, overlayRef: o, fadeFromIndex: a, onSnapPointChange: u, direction: i = "bottom", container: d, snapToSequentialPoint: l }) {
  const [c, m] = tn({
    prop: e,
    defaultProp: n == null ? void 0 : n[0],
    onChange: t
  }), [p, R] = f.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  f.useEffect(() => {
    function v() {
      R({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", v), () => window.removeEventListener("resize", v);
  }, []);
  const P = f.useMemo(() => c === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    c
  ]), w = f.useMemo(() => {
    var v;
    return (v = n == null ? void 0 : n.findIndex((S) => S === c)) != null ? v : null;
  }, [
    n,
    c
  ]), A = n && n.length > 0 && (a || a === 0) && !Number.isNaN(a) && n[a] === c || !n, g = f.useMemo(() => {
    const v = d ? {
      width: d.getBoundingClientRect().width,
      height: d.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var S;
    return (S = n == null ? void 0 : n.map((T) => {
      const L = typeof T == "string";
      let k = 0;
      if (L && (k = parseInt(T, 10)), $(i)) {
        const E = L ? k : p ? T * v.height : 0;
        return p ? i === "bottom" ? v.height - E : -v.height + E : E;
      }
      const j = L ? k : p ? T * v.width : 0;
      return p ? i === "right" ? v.width - j : -v.width + j : j;
    })) != null ? S : [];
  }, [
    n,
    p,
    d
  ]), _ = f.useMemo(() => w !== null ? g == null ? void 0 : g[w] : null, [
    g,
    w
  ]), O = f.useCallback((v) => {
    var S;
    const T = (S = g == null ? void 0 : g.findIndex((L) => L === v)) != null ? S : null;
    u(T), F(r.current, {
      transition: `transform ${I.DURATION}s cubic-bezier(${I.EASE.join(",")})`,
      transform: $(i) ? `translate3d(0, ${v}px, 0)` : `translate3d(${v}px, 0, 0)`
    }), g && T !== g.length - 1 && a !== void 0 && T !== a && T < a ? F(o.current, {
      transition: `opacity ${I.DURATION}s cubic-bezier(${I.EASE.join(",")})`,
      opacity: "0"
    }) : F(o.current, {
      transition: `opacity ${I.DURATION}s cubic-bezier(${I.EASE.join(",")})`,
      opacity: "1"
    }), m(n == null ? void 0 : n[Math.max(T, 0)]);
  }, [
    r.current,
    n,
    g,
    a,
    o,
    m
  ]);
  f.useEffect(() => {
    if (c || e) {
      var v;
      const S = (v = n == null ? void 0 : n.findIndex((T) => T === e || T === c)) != null ? v : -1;
      g && S !== -1 && typeof g[S] == "number" && O(g[S]);
    }
  }, [
    c,
    e,
    n,
    g,
    O
  ]);
  function h({ draggedDistance: v, closeDrawer: S, velocity: T, dismissible: L }) {
    if (a === void 0) return;
    const k = i === "bottom" || i === "right" ? (_ ?? 0) - v : (_ ?? 0) + v, j = w === a - 1, E = w === 0, z = v > 0;
    if (j && F(o.current, {
      transition: `opacity ${I.DURATION}s cubic-bezier(${I.EASE.join(",")})`
    }), !l && T > 2 && !z) {
      L ? S() : O(g[0]);
      return;
    }
    if (!l && T > 2 && z && g && n) {
      O(g[n.length - 1]);
      return;
    }
    const B = g == null ? void 0 : g.reduce((U, J) => typeof U != "number" || typeof J != "number" ? U : Math.abs(J - k) < Math.abs(U - k) ? J : U), q = $(i) ? window.innerHeight : window.innerWidth;
    if (T > Jt && Math.abs(v) < q * 0.4) {
      const U = z ? 1 : -1;
      if (U > 0 && P && n) {
        O(g[n.length - 1]);
        return;
      }
      if (E && U < 0 && L && S(), w === null) return;
      O(g[w + U]);
      return;
    }
    O(B);
  }
  function W({ draggedDistance: v }) {
    if (_ === null) return;
    const S = i === "bottom" || i === "right" ? _ - v : _ + v;
    (i === "bottom" || i === "right") && S < g[g.length - 1] || (i === "top" || i === "left") && S > g[g.length - 1] || F(r.current, {
      transform: $(i) ? `translate3d(0, ${S}px, 0)` : `translate3d(${S}px, 0, 0)`
    });
  }
  function X(v, S) {
    if (!n || typeof w != "number" || !g || a === void 0) return null;
    const T = w === a - 1;
    if (w >= a && S)
      return 0;
    if (T && !S) return 1;
    if (!A && !T) return null;
    const k = T ? w + 1 : w - 1, j = T ? g[k] - g[k - 1] : g[k + 1] - g[k], E = v / Math.abs(j);
    return T ? 1 - E : E;
  }
  return {
    isLastSnapPoint: P,
    activeSnapPoint: c,
    shouldFade: A,
    getPercentageDragged: X,
    setActiveSnapPoint: m,
    activeSnapPointIndex: w,
    onRelease: h,
    onDrag: W,
    snapPointsOffset: g
  };
}
const qr = () => () => {
};
function Yr() {
  const { direction: e, isOpen: t, shouldScaleBackground: n, setBackgroundColorOnScale: r, noBodyStyles: o } = Re(), a = f.useRef(null), u = En(() => document.body.style.backgroundColor, []);
  function i() {
    return (window.innerWidth - Ge) / window.innerWidth;
  }
  f.useEffect(() => {
    if (t && n) {
      a.current && clearTimeout(a.current);
      const d = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!d) return;
      Br(r && !o ? je(document.body, {
        background: "black"
      }) : qr, je(d, {
        transformOrigin: $(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${I.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${I.EASE.join(",")})`
      }));
      const l = je(d, {
        borderRadius: `${Qt}px`,
        overflow: "hidden",
        ...$(e) ? {
          transform: `scale(${i()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${i()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        l(), a.current = window.setTimeout(() => {
          u ? document.body.style.background = u : document.body.style.removeProperty("background");
        }, I.DURATION * 1e3);
      };
    }
  }, [
    t,
    n,
    u
  ]);
}
let Ee = null;
function Kr({ isOpen: e, modal: t, nested: n, hasBeenOpened: r, preventScrollRestoration: o, noBodyStyles: a }) {
  const [u, i] = f.useState(() => typeof window < "u" ? window.location.href : ""), d = f.useRef(0), l = f.useCallback(() => {
    if (yt() && Ee === null && e && !a) {
      Ee = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: m, innerHeight: p } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-d.current}px`,
        left: `${-m}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const R = p - window.innerHeight;
        R && d.current >= p && (document.body.style.top = `${-(d.current + R)}px`);
      }), 300);
    }
  }, [
    e
  ]), c = f.useCallback(() => {
    if (yt() && Ee !== null && !a) {
      const m = -parseInt(document.body.style.top, 10), p = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, Ee), window.requestAnimationFrame(() => {
        if (o && u !== window.location.href) {
          i(window.location.href);
          return;
        }
        window.scrollTo(p, m);
      }), Ee = null;
    }
  }, [
    u
  ]);
  return f.useEffect(() => {
    function m() {
      d.current = window.scrollY;
    }
    return m(), window.addEventListener("scroll", m), () => {
      window.removeEventListener("scroll", m);
    };
  }, []), f.useEffect(() => {
    if (t)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || c();
      };
  }, [
    t,
    c
  ]), f.useEffect(() => {
    n || !r || (e ? (!window.matchMedia("(display-mode: standalone)").matches && l(), t || window.setTimeout(() => {
      c();
    }, 500)) : c());
  }, [
    e,
    r,
    u,
    t,
    n,
    l,
    c
  ]), {
    restorePositionSetting: c
  };
}
function Gr({ open: e, onOpenChange: t, children: n, onDrag: r, onRelease: o, snapPoints: a, shouldScaleBackground: u = !1, setBackgroundColorOnScale: i = !0, closeThreshold: d = Hr, scrollLockTimeout: l = Vr, dismissible: c = !0, handleOnly: m = !1, fadeFromIndex: p = a && a.length - 1, activeSnapPoint: R, setActiveSnapPoint: P, fixed: w, modal: A = !0, onClose: g, nested: _, noBodyStyles: O = !1, direction: h = "bottom", defaultOpen: W = !1, disablePreventScroll: X = !0, snapToSequentialPoint: v = !1, preventScrollRestoration: S = !1, repositionInputs: T = !0, onAnimationEnd: L, container: k, autoFocus: j = !1 }) {
  var E, z;
  const [B = !1, q] = tn({
    defaultProp: W,
    prop: e,
    onChange: (y) => {
      t == null || t(y), !y && !_ && fn(), setTimeout(() => {
        L == null || L(y);
      }, I.DURATION * 1e3), y && !A && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), y || (document.body.style.pointerEvents = "auto");
    }
  }), [U, J] = f.useState(!1), [ee, pe] = f.useState(!1), [an, et] = f.useState(!1), le = f.useRef(null), Se = f.useRef(null), Me = f.useRef(null), $e = f.useRef(null), ve = f.useRef(null), ge = f.useRef(!1), Le = f.useRef(null), Fe = f.useRef(0), ce = f.useRef(!1), tt = f.useRef(!W), nt = f.useRef(0), b = f.useRef(null), rt = f.useRef(((E = b.current) == null ? void 0 : E.getBoundingClientRect().height) || 0), ot = f.useRef(((z = b.current) == null ? void 0 : z.getBoundingClientRect().width) || 0), ke = f.useRef(0), sn = f.useCallback((y) => {
    a && y === he.length - 1 && (Se.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: un, activeSnapPointIndex: de, setActiveSnapPoint: at, onRelease: ln, snapPointsOffset: he, onDrag: cn, shouldFade: it, getPercentageDragged: dn } = jr({
    snapPoints: a,
    activeSnapPointProp: R,
    setActiveSnapPointProp: P,
    drawerRef: b,
    fadeFromIndex: p,
    overlayRef: le,
    onSnapPointChange: sn,
    direction: h,
    container: k,
    snapToSequentialPoint: v
  });
  Mr({
    isDisabled: !B || ee || !A || an || !U || !T || !X
  });
  const { restorePositionSetting: fn } = Kr({
    isOpen: B,
    modal: A,
    nested: _ ?? !1,
    hasBeenOpened: U,
    preventScrollRestoration: S,
    noBodyStyles: O
  });
  function Te() {
    return (window.innerWidth - Ge) / window.innerWidth;
  }
  function mn(y) {
    var N, x;
    !c && !a || b.current && !b.current.contains(y.target) || (rt.current = ((N = b.current) == null ? void 0 : N.getBoundingClientRect().height) || 0, ot.current = ((x = b.current) == null ? void 0 : x.getBoundingClientRect().width) || 0, pe(!0), Me.current = /* @__PURE__ */ new Date(), Kt() && window.addEventListener("touchend", () => ge.current = !1, {
      once: !0
    }), y.target.setPointerCapture(y.pointerId), Fe.current = $(h) ? y.pageY : y.pageX);
  }
  function st(y, N) {
    var x;
    let C = y;
    const M = (x = window.getSelection()) == null ? void 0 : x.toString(), V = b.current ? Pe(b.current, h) : null, H = /* @__PURE__ */ new Date();
    if (C.tagName === "SELECT" || C.hasAttribute("data-vaul-no-drag") || C.closest("[data-vaul-no-drag]"))
      return !1;
    if (h === "right" || h === "left")
      return !0;
    if (Se.current && H.getTime() - Se.current.getTime() < 500)
      return !1;
    if (V !== null && (h === "bottom" ? V > 0 : V < 0))
      return !0;
    if (M && M.length > 0)
      return !1;
    if (ve.current && H.getTime() - ve.current.getTime() < l && V === 0 || N)
      return ve.current = H, !1;
    for (; C; ) {
      if (C.scrollHeight > C.clientHeight) {
        if (C.scrollTop !== 0)
          return ve.current = /* @__PURE__ */ new Date(), !1;
        if (C.getAttribute("role") === "dialog")
          return !0;
      }
      C = C.parentNode;
    }
    return !0;
  }
  function pn(y) {
    if (b.current && ee) {
      const N = h === "bottom" || h === "right" ? 1 : -1, x = (Fe.current - ($(h) ? y.pageY : y.pageX)) * N, C = x > 0, M = a && !c && !C;
      if (M && de === 0) return;
      const V = Math.abs(x), H = document.querySelector("[data-vaul-drawer-wrapper]"), te = h === "bottom" || h === "top" ? rt.current : ot.current;
      let Y = V / te;
      const ae = dn(V, C);
      if (ae !== null && (Y = ae), M && Y >= 1 || !ge.current && !st(y.target, C)) return;
      if (b.current.classList.add(qe), ge.current = !0, F(b.current, {
        transition: "none"
      }), F(le.current, {
        transition: "none"
      }), a && cn({
        draggedDistance: x
      }), C && !a) {
        const Z = Wr(x), Ce = Math.min(Z * -1, 0) * N;
        F(b.current, {
          transform: $(h) ? `translate3d(0, ${Ce}px, 0)` : `translate3d(${Ce}px, 0, 0)`
        });
        return;
      }
      const ne = 1 - Y;
      if ((it || p && de === p - 1) && (r == null || r(y, Y), F(le.current, {
        opacity: `${ne}`,
        transition: "none"
      }, !0)), H && le.current && u) {
        const Z = Math.min(Te() + Y * (1 - Te()), 1), Ce = 8 - Y * 8, lt = Math.max(0, 14 - Y * 14);
        F(H, {
          borderRadius: `${Ce}px`,
          transform: $(h) ? `scale(${Z}) translate3d(0, ${lt}px, 0)` : `scale(${Z}) translate3d(${lt}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!a) {
        const Z = V * N;
        F(b.current, {
          transform: $(h) ? `translate3d(0, ${Z}px, 0)` : `translate3d(${Z}px, 0, 0)`
        });
      }
    }
  }
  f.useEffect(() => {
    window.requestAnimationFrame(() => {
      tt.current = !0;
    });
  }, []), f.useEffect(() => {
    var y;
    function N() {
      if (!b.current || !T) return;
      const x = document.activeElement;
      if (Ke(x) || ce.current) {
        var C;
        const M = ((C = window.visualViewport) == null ? void 0 : C.height) || 0, V = window.innerHeight;
        let H = V - M;
        const te = b.current.getBoundingClientRect().height || 0, Y = te > V * 0.8;
        ke.current || (ke.current = te);
        const ae = b.current.getBoundingClientRect().top;
        if (Math.abs(nt.current - H) > 60 && (ce.current = !ce.current), a && a.length > 0 && he && de) {
          const ne = he[de] || 0;
          H += ne;
        }
        if (nt.current = H, te > M || ce.current) {
          const ne = b.current.getBoundingClientRect().height;
          let Z = ne;
          ne > M && (Z = M - (Y ? ae : Ge)), w ? b.current.style.height = `${ne - Math.max(H, 0)}px` : b.current.style.height = `${Math.max(Z, M - ae)}px`;
        } else Or() || (b.current.style.height = `${ke.current}px`);
        a && a.length > 0 && !ce.current ? b.current.style.bottom = "0px" : b.current.style.bottom = `${Math.max(H, 0)}px`;
      }
    }
    return (y = window.visualViewport) == null || y.addEventListener("resize", N), () => {
      var x;
      return (x = window.visualViewport) == null ? void 0 : x.removeEventListener("resize", N);
    };
  }, [
    de,
    a,
    he
  ]);
  function we(y) {
    vn(), g == null || g(), y || q(!1), setTimeout(() => {
      a && at(a[0]);
    }, I.DURATION * 1e3);
  }
  function ut() {
    if (!b.current) return;
    const y = document.querySelector("[data-vaul-drawer-wrapper]"), N = Pe(b.current, h);
    F(b.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${I.DURATION}s cubic-bezier(${I.EASE.join(",")})`
    }), F(le.current, {
      transition: `opacity ${I.DURATION}s cubic-bezier(${I.EASE.join(",")})`,
      opacity: "1"
    }), u && N && N > 0 && B && F(y, {
      borderRadius: `${Qt}px`,
      overflow: "hidden",
      ...$(h) ? {
        transform: `scale(${Te()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${Te()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${I.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${I.EASE.join(",")})`
    }, !0);
  }
  function vn() {
    !ee || !b.current || (b.current.classList.remove(qe), ge.current = !1, pe(!1), $e.current = /* @__PURE__ */ new Date());
  }
  function gn(y) {
    if (!ee || !b.current) return;
    b.current.classList.remove(qe), ge.current = !1, pe(!1), $e.current = /* @__PURE__ */ new Date();
    const N = Pe(b.current, h);
    if (!y || !st(y.target, !1) || !N || Number.isNaN(N) || Me.current === null) return;
    const x = $e.current.getTime() - Me.current.getTime(), C = Fe.current - ($(h) ? y.pageY : y.pageX), M = Math.abs(C) / x;
    if (M > 0.05 && (et(!0), setTimeout(() => {
      et(!1);
    }, 200)), a) {
      ln({
        draggedDistance: C * (h === "bottom" || h === "right" ? 1 : -1),
        closeDrawer: we,
        velocity: M,
        dismissible: c
      }), o == null || o(y, !0);
      return;
    }
    if (h === "bottom" || h === "right" ? C > 0 : C < 0) {
      ut(), o == null || o(y, !0);
      return;
    }
    if (M > Jt) {
      we(), o == null || o(y, !1);
      return;
    }
    var V;
    const H = Math.min((V = b.current.getBoundingClientRect().height) != null ? V : 0, window.innerHeight);
    var te;
    const Y = Math.min((te = b.current.getBoundingClientRect().width) != null ? te : 0, window.innerWidth), ae = h === "left" || h === "right";
    if (Math.abs(N) >= (ae ? Y : H) * d) {
      we(), o == null || o(y, !1);
      return;
    }
    o == null || o(y, !0), ut();
  }
  f.useEffect(() => (B && (F(document.documentElement, {
    scrollBehavior: "auto"
  }), Se.current = /* @__PURE__ */ new Date()), () => {
    Ur(document.documentElement, "scrollBehavior");
  }), [
    B
  ]);
  function hn(y) {
    const N = y ? (window.innerWidth - ie) / window.innerWidth : 1, x = y ? -ie : 0;
    Le.current && window.clearTimeout(Le.current), F(b.current, {
      transition: `transform ${I.DURATION}s cubic-bezier(${I.EASE.join(",")})`,
      transform: $(h) ? `scale(${N}) translate3d(0, ${x}px, 0)` : `scale(${N}) translate3d(${x}px, 0, 0)`
    }), !y && b.current && (Le.current = setTimeout(() => {
      const C = Pe(b.current, h);
      F(b.current, {
        transition: "none",
        transform: $(h) ? `translate3d(0, ${C}px, 0)` : `translate3d(${C}px, 0, 0)`
      });
    }, 500));
  }
  function wn(y, N) {
    if (N < 0) return;
    const x = (window.innerWidth - ie) / window.innerWidth, C = x + N * (1 - x), M = -ie + N * ie;
    F(b.current, {
      transform: $(h) ? `scale(${C}) translate3d(0, ${M}px, 0)` : `scale(${C}) translate3d(${M}px, 0, 0)`,
      transition: "none"
    });
  }
  function yn(y, N) {
    const x = $(h) ? window.innerHeight : window.innerWidth, C = N ? (x - ie) / x : 1, M = N ? -ie : 0;
    N && F(b.current, {
      transition: `transform ${I.DURATION}s cubic-bezier(${I.EASE.join(",")})`,
      transform: $(h) ? `scale(${C}) translate3d(0, ${M}px, 0)` : `scale(${C}) translate3d(${M}px, 0, 0)`
    });
  }
  return f.useEffect(() => {
    A || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    A
  ]), /* @__PURE__ */ f.createElement(wr, {
    defaultOpen: W,
    onOpenChange: (y) => {
      !c && !y || (y ? J(!0) : we(!0), q(y));
    },
    open: B
  }, /* @__PURE__ */ f.createElement(Yt.Provider, {
    value: {
      activeSnapPoint: un,
      snapPoints: a,
      setActiveSnapPoint: at,
      drawerRef: b,
      overlayRef: le,
      onOpenChange: t,
      onPress: mn,
      onRelease: gn,
      onDrag: pn,
      dismissible: c,
      shouldAnimate: tt,
      handleOnly: m,
      isOpen: B,
      isDragging: ee,
      shouldFade: it,
      closeDrawer: we,
      onNestedDrag: wn,
      onNestedOpenChange: hn,
      onNestedRelease: yn,
      keyboardIsOpen: ce,
      modal: A,
      snapPointsOffset: he,
      activeSnapPointIndex: de,
      direction: h,
      shouldScaleBackground: u,
      setBackgroundColorOnScale: i,
      noBodyStyles: O,
      container: k,
      autoFocus: j
    }
  }, n));
}
const nn = /* @__PURE__ */ f.forwardRef(function({ ...e }, t) {
  const { overlayRef: n, snapPoints: r, onRelease: o, shouldFade: a, isOpen: u, modal: i, shouldAnimate: d } = Re(), l = Xt(t, n), c = r && r.length > 0;
  if (!i)
    return null;
  const m = f.useCallback((p) => o(p), [
    o
  ]);
  return /* @__PURE__ */ f.createElement(br, {
    onMouseUp: m,
    ref: l,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": u && c ? "true" : "false",
    "data-vaul-snap-points-overlay": u && a ? "true" : "false",
    "data-vaul-animate": d != null && d.current ? "true" : "false",
    ...e
  });
});
nn.displayName = "Drawer.Overlay";
const rn = /* @__PURE__ */ f.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: n, ...r }, o) {
  const { drawerRef: a, onPress: u, onRelease: i, onDrag: d, keyboardIsOpen: l, snapPointsOffset: c, activeSnapPointIndex: m, modal: p, isOpen: R, direction: P, snapPoints: w, container: A, handleOnly: g, shouldAnimate: _, autoFocus: O } = Re(), [h, W] = f.useState(!1), X = Xt(o, a), v = f.useRef(null), S = f.useRef(null), T = f.useRef(!1), L = w && w.length > 0;
  Yr();
  const k = (E, z, B = 0) => {
    if (T.current) return !0;
    const q = Math.abs(E.y), U = Math.abs(E.x), J = U > q, ee = [
      "bottom",
      "right"
    ].includes(z) ? 1 : -1;
    if (z === "left" || z === "right") {
      if (!(E.x * ee < 0) && U >= 0 && U <= B)
        return J;
    } else if (!(E.y * ee < 0) && q >= 0 && q <= B)
      return !J;
    return T.current = !0, !0;
  };
  f.useEffect(() => {
    L && window.requestAnimationFrame(() => {
      W(!0);
    });
  }, []);
  function j(E) {
    v.current = null, T.current = !1, i(E);
  }
  return /* @__PURE__ */ f.createElement(Dr, {
    "data-vaul-drawer-direction": P,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": h ? "true" : "false",
    "data-vaul-snap-points": R && L ? "true" : "false",
    "data-vaul-custom-container": A ? "true" : "false",
    "data-vaul-animate": _ != null && _.current ? "true" : "false",
    ...r,
    ref: X,
    style: c && c.length > 0 ? {
      "--snap-point-height": `${c[m ?? 0]}px`,
      ...t
    } : t,
    onPointerDown: (E) => {
      g || (r.onPointerDown == null || r.onPointerDown.call(r, E), v.current = {
        x: E.pageX,
        y: E.pageY
      }, u(E));
    },
    onOpenAutoFocus: (E) => {
      n == null || n(E), O || E.preventDefault();
    },
    onPointerDownOutside: (E) => {
      if (e == null || e(E), !p || E.defaultPrevented) {
        E.preventDefault();
        return;
      }
      l.current && (l.current = !1);
    },
    onFocusOutside: (E) => {
      if (!p) {
        E.preventDefault();
        return;
      }
    },
    onPointerMove: (E) => {
      if (S.current = E, g || (r.onPointerMove == null || r.onPointerMove.call(r, E), !v.current)) return;
      const z = E.pageY - v.current.y, B = E.pageX - v.current.x, q = E.pointerType === "touch" ? 10 : 2;
      k({
        x: B,
        y: z
      }, P, q) ? d(E) : (Math.abs(B) > q || Math.abs(z) > q) && (v.current = null);
    },
    onPointerUp: (E) => {
      r.onPointerUp == null || r.onPointerUp.call(r, E), v.current = null, T.current = !1, i(E);
    },
    onPointerOut: (E) => {
      r.onPointerOut == null || r.onPointerOut.call(r, E), j(S.current);
    },
    onContextMenu: (E) => {
      r.onContextMenu == null || r.onContextMenu.call(r, E), S.current && j(S.current);
    }
  });
});
rn.displayName = "Drawer.Content";
const Xr = 250, Zr = 120, Jr = /* @__PURE__ */ f.forwardRef(function({ preventCycle: e = !1, children: t, ...n }, r) {
  const { closeDrawer: o, isDragging: a, snapPoints: u, activeSnapPoint: i, setActiveSnapPoint: d, dismissible: l, handleOnly: c, isOpen: m, onPress: p, onDrag: R } = Re(), P = f.useRef(null), w = f.useRef(!1);
  function A() {
    if (w.current) {
      O();
      return;
    }
    window.setTimeout(() => {
      g();
    }, Zr);
  }
  function g() {
    if (a || e || w.current) {
      O();
      return;
    }
    if (O(), !u || u.length === 0) {
      l || o();
      return;
    }
    if (i === u[u.length - 1] && l) {
      o();
      return;
    }
    const W = u.findIndex((v) => v === i);
    if (W === -1) return;
    const X = u[W + 1];
    d(X);
  }
  function _() {
    P.current = window.setTimeout(() => {
      w.current = !0;
    }, Xr);
  }
  function O() {
    P.current && window.clearTimeout(P.current), w.current = !1;
  }
  return /* @__PURE__ */ f.createElement("div", {
    onClick: A,
    onPointerCancel: O,
    onPointerDown: (h) => {
      c && p(h), _();
    },
    onPointerMove: (h) => {
      c && R(h);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": m ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ f.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
Jr.displayName = "Drawer.Handle";
function Qr(e) {
  const t = Re(), { container: n = t.container, ...r } = e;
  return /* @__PURE__ */ f.createElement(Er, {
    container: n,
    ...r
  });
}
const G = {
  Root: Gr,
  Content: rn,
  Overlay: nn,
  Trigger: yr,
  Portal: Qr,
  Close: Tr,
  Title: Rr,
  Description: Sr
}, eo = "_drawerOverlay_q8vk3_39", to = "_drawerContent_q8vk3_45", no = "_drawerHeader_q8vk3_58", ro = "_drawerFooter_q8vk3_70", oo = "_drawerTitle_q8vk3_78", ao = "_drawerDescription_q8vk3_84", me = {
  drawerOverlay: eo,
  drawerContent: to,
  drawerHeader: no,
  drawerFooter: ro,
  drawerTitle: oo,
  drawerDescription: ao
}, io = ({ shouldScaleBackground: e = !0, ...t }) => /* @__PURE__ */ D(G.Root, { shouldScaleBackground: e, ...t });
io.displayName = "Drawer";
const Eo = G.Trigger, so = G.Portal, bo = G.Close, on = s.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ D(G.Overlay, { className: fe(me.drawerOverlay, e), ref: n, ...t }));
on.displayName = G.Overlay.displayName;
const uo = s.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ xe(so, { children: [
  /* @__PURE__ */ D(on, {}),
  /* @__PURE__ */ xe(
    G.Content,
    {
      className: fe(me.drawerContent, t),
      "data-cxy-name": "drawer",
      ref: r,
      ...n,
      children: [
        /* @__PURE__ */ D("div", { className: "mx-auto mt-4 h-2 w-[100px] rounded-full bg-muted" }),
        e
      ]
    }
  )
] }));
uo.displayName = "DrawerContent";
const lo = ({ className: e, ...t }) => /* @__PURE__ */ D("div", { className: fe(me.drawerHeader, e), ...t });
lo.displayName = "DrawerHeader";
const co = ({ className: e, ...t }) => /* @__PURE__ */ D("div", { className: fe(me.drawerFooter, e), ...t });
co.displayName = "DrawerFooter";
const fo = s.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ D(G.Title, { className: fe(me.drawerTitle, e), ref: n, ...t }));
fo.displayName = G.Title.displayName;
const mo = s.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ D(G.Description, { className: fe(me.drawerDescription, e), ref: n, ...t }));
mo.displayName = G.Description.displayName;
export {
  io as Drawer,
  bo as DrawerClose,
  uo as DrawerContent,
  mo as DrawerDescription,
  co as DrawerFooter,
  lo as DrawerHeader,
  on as DrawerOverlay,
  so as DrawerPortal,
  fo as DrawerTitle,
  Eo as DrawerTrigger
};
